import { render, staticRenderFns } from "./DirectAppointmentSelectRoomPage.vue?vue&type=template&id=320300a6"
import script from "./DirectAppointmentSelectRoomPage.vue?vue&type=script&lang=ts"
export * from "./DirectAppointmentSelectRoomPage.vue?vue&type=script&lang=ts"
import style0 from "./DirectAppointmentSelectRoomPage.vue?vue&type=style&index=0&id=320300a6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports